import styled from 'styled-components';
import { FlexBoxRow, FlexBoxCol } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Throbber from '@ertelecom/ui-react/components/throbber/throbber';

export const breakPoints = {
    desktop: '1600px',
    sDesktop: '1365px',
    tablet: '1023px',
    mobile: '767px',
};

export const Row = styled(FlexBoxRow)`
    width: 100%;
`;

export const Col = styled(FlexBoxCol)`
    margin-bottom: 50px;

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 30px;
    }
`;

export const Wrapper = styled.div`
    margin-top: 100px;
    color: ${COLORS.black};
    position:relative;
    width: 100%;
    
    @media (max-width: ${breakPoints.desktop}) {
        
        margin-left: 0;
        margin-right: 0;
        
        & > div {
            width: 100%;
        }
    }
    
    @media (max-width: ${breakPoints.sDesktop}) {
        overflow: hidden;   
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 50px;
        
        & > div {
            width: 98.594%;
        }
    }
`;

export const Preloader = styled(Throbber)`
    position: fixed;
    width: 100px;
    height: 100px;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    transform: translate(0, 0);
`;
